function forceHideWatermarkElements() {
    const elements = document.querySelectorAll('.tmenu-watermark');
    elements.forEach(element => {
        element.setAttribute('style', 'display: none !important;');
    });
}

// Assuming there is at least one element with the class 'site-nav-container'
const target = document.querySelector('.site-nav-container');

if (target) {
    const observer = new MutationObserver(mutations => {
        let relevantMutationFound = false;
    
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length && !relevantMutationFound) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && (node.matches('.tmenu-watermark') || node.querySelector('.tmenu-watermark'))) {
                        relevantMutationFound = true;
                        break;
                    }
                }
            }
        });
    
        if (relevantMutationFound) {
            forceHideWatermarkElements();
        }
    });
    
    const observerOptions = {
        childList: true,
        subtree: true
    };
    
    observer.observe(target, observerOptions);
    forceHideWatermarkElements();
} else {
    console.error("Target element '.site-nav-container' not found.");
}


// if (typeof usf !== 'undefined') {
//     function patchUSFsaleTxt() {
//         var newComp = RVue.options.components['usf-new-griditem'];
//         if (!newComp || !newComp.options || !newComp.options.computed) {
//             setTimeout(patchUSFsaleTxt, 100);
//             return;
//         }

//         newComp.options.computed.saleTxt = function() {
//             if (this.hasDiscount && usf.settings.search.showSale) {
//                 if (_usfGlobalSettings.product_card_badge_sale_type == 'percentage') {
//                     if (this.priceVaries && !this.product.selectedVariantId) {
//                         var discountedVariants = this.product.variants.filter(v =>
//                             v.compareAtPrice && v.compareAtPrice > v.price
//                         );
//                         if (discountedVariants.length === 0) return this.loc.sale;
//                         var percents = discountedVariants.map(v =>
//                             Math.round(100 - v.price * 100 / v.compareAtPrice)
//                         );
//                         var maxPercent = Math.max(...percents);
//                         var minPercent = Math.min(...percents);
//                         var saved = '-' + maxPercent + '%';
//                         return minPercent === maxPercent ? saved : _usfSalePercentTxt.replace('{{ percent }}', saved);
//                     } else {
//                         var compare_at_price = this.selectedVariantForPrice.compareAtPrice;
//                         var _price = this.selectedVariantForPrice.price;
//                         return '-' + Math.round(100 - _price * 100 / compare_at_price) + '%';
//                     }
//                 } else if (_usfGlobalSettings.product_card_badge_sale_type == 'amount') {
//                     var compare_at_price = this.selectedVariantForPrice.compareAtPrice;
//                     var _price = this.selectedVariantForPrice.price;
//                     if (this.priceVaries && !this.product.selectedVariantId) {
//                         var maxSaving = 0;
//                         this.product.variants.forEach(v => {
//                             if (v.compareAtPrice && v.compareAtPrice > v.price) {
//                                 var saving = v.compareAtPrice - v.price;
//                                 if (saving > maxSaving) {
//                                     maxSaving = saving;
//                                     compare_at_price = v.compareAtPrice;
//                                     _price = v.price;
//                                 }
//                             }
//                         });
//                         return _usfSaveUpToAmountHtml.replace('{{ amount }}', usf.utils.getDisplayPrice(compare_at_price - _price));
//                     } else {
//                         return _usfSaveAmountHtml.replace('{{ amount }}', usf.utils.getDisplayPrice(compare_at_price - _price));
//                     }
//                 } else {
//                     return this.loc.sale;
//                 }
//             } else {
//                 return 0;
//             }
//         };

//         console.log("saleTxt patched on newComp.options.computed");
//     }

//     // Run immediately and also after sr_updated so it catches lazy-loaded results
//     patchUSFsaleTxt();
//     usf.event.add('sr_updated', patchUSFsaleTxt);
// }

// jQuery(document).ready(function($){
//     if (window.location.pathname == '/') {
//         var reviewBlock = $('.jdgm-medals-wrapper');
//         if (reviewBlock.length > 0) {
//             var reviewBlockSection = reviewBlock.closest('.shopify-section');
//             var prevSection = reviewBlockSection.prev();
//             var targetPlace = prevSection.find('.rich-text__text .card__text');
//             reviewBlock.clone().addClass('cloned-review-badge').css('flex-direction', 'row').appendTo(targetPlace);
//             // $('.cloned-review-badge .jdgm-verified-wrapper').remove();
//             // $('.cloned-review-badge .jdgm-medals-separator').remove();
//             $('.cloned-review-badge .jdgm-medals__container').css('display', 'flex');
//             reviewBlockSection.remove();
//         }
//     }
// });